export default __webpack_public_path__ + "static/media/WhitePlus.417eb8b0.svg";